import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';

const PurplePreset = definePreset(Lara, {
  semantic: {
    primary: {
      50: '#f9f7ff', // --primary-50
      100: '#e3d8fd', // --primary-100
      200: '#cdb9fb', // --primary-200
      300: '#b79af9', // --primary-300
      400: '#a17bf8', // --primary-400
      500: '#4e2d82', // --primary-500 (your main color)
      600: '#764ed1', // --primary-600
      700: '#6140ac', // --primary-700
      800: '#4c3387', // --primary-800
      900: '#382562', // --primary-900
      950: '#2a1b47', // Darker shade for better contrast
    },
    colorScheme: {
      light: {
        // surface: {
        //   0: '#ffffff',     // --surface-0
        //   50: '#fafafa',    // --surface-50
        //   100: '#f5f5f5',   // --surface-100
        //   200: '#eeeeee',   // --surface-200
        //   300: '#e0e0e0',   // --surface-300
        //   400: '#bdbdbd',   // --surface-400
        //   500: '#9e9e9e',   // --surface-500
        //   600: '#757575',   // --surface-600
        //   700: '#1e293b',   // --surface-700
        //   800: '#424242',   // --surface-800
        //   900: '#212121',   // --surface-900
        //   ground: '#eff3f8',  // --surface-ground
        //   section: '#ffffff', // --surface-section
        //   card: '#ffffff',    // --surface-card
        //   overlay: '#ffffff', // --surface-overlay
        //   border: '#dfe7ef',  // --surface-border
        //   hover: '#f6f9fc',    // --surface-hover
        //   a: '#ffffff',
        //   b: '#f8fafc',
        //   c: '#f1f5f9',
        //   d: '#e2e8f0',
        //   e: '#ffffff',
        //   f: '#ffffff'
        // },
        content: {
          color: '#1e293b', // --text-color
        },
      },
    },
  },

  global: {},

  components: {
    tag: {
      colorScheme: {
        light: {
          success: {
            background: 'rgba(34, 197, 94, 0.16)', // Light green (16% opacity)
            color: '#15803d', // Darker green text
          },
          warn: {
            background: 'rgba(234, 179, 8, 0.16)', // Light yellow (16% opacity)
            color: '#a16207', // Darker yellow text
          },
          danger: {
            background: 'rgba(239, 68, 68, 0.16)', // Light red (16% opacity)
            color: '#b91c1c', // Darker red text
          },
          info: {
            background: 'rgba(59, 130, 246, 0.16)', // Light blue (16% opacity)
            color: '#1e40af', // Darker blue text
          },
        },
      },
    },
  },
});

export default PurplePreset;
